"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var _default = function _default(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(ElementHandlers, _Component);

    function ElementHandlers() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, ElementHandlers);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ElementHandlers)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.getUpdatedAnchors = function (x, y) {
        var anchors = _this.props.element.anchors;
        var headAnchor = (0, _ramda.head)(anchors);
        var xDifference = x - headAnchor.x;
        var yDifference = y - headAnchor.y;
        return anchors.map(function (a) {
          return _objectSpread({}, a, {
            x: a.x + xDifference,
            y: a.y + yDifference
          });
        });
      };

      _this.onDragMove = function (e) {
        var _this$props = _this.props,
            element = _this$props.element,
            onChange = _this$props.onChange;
        var x = e.target.x();
        var y = e.target.y();
        onChange(_objectSpread({}, element, {
          x: x,
          y: y
        }, element.anchors ? {
          anchors: _this.getUpdatedAnchors(x, y)
        } : {}));
      };

      _this.onTransform = function (e) {
        var _this$props2 = _this.props,
            element = _this$props2.element,
            onChange = _this$props2.onChange;
        onChange(_objectSpread({}, element, {
          x: e.currentTarget.x(),
          y: e.currentTarget.y(),
          rotation: e.currentTarget.rotation(),
          scaleX: e.currentTarget.scaleX(),
          scaleY: e.currentTarget.scaleY()
        }));
      };

      _this.showHelper = function () {
        var element = _this.props.element;
        return Math.ceil(element.width * (element.scaleX || 1)) < 6 || Math.ceil(element.height * (element.scaleY || 1)) < 6;
      };

      _this.getHelperWidth = function () {
        var element = _this.props.element;
        return Math.ceil(element.width * (element.scaleX || 1)) < 5 ? Math.ceil(5 / (element.scaleX || 1)) : element.width;
      };

      _this.getHelperHeight = function () {
        var element = _this.props.element;
        return Math.ceil(element.height * (element.scaleY || 1)) < 5 ? Math.ceil(5 / (element.scaleY || 1)) : element.height;
      };

      return _this;
    }

    _createClass(ElementHandlers, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, _extends({}, this.props, {
          onDragMove: this.onDragMove,
          onTransform: this.onTransform,
          showHelper: this.showHelper(),
          helperWidth: this.getHelperWidth(),
          helperHeight: this.getHelperHeight()
        }));
      }
    }]);

    return ElementHandlers;
  }(_react.Component), _class.propTypes = {
    element: _propTypes.default.object,
    onChange: _propTypes.default.func
  }, _temp;
};

exports.default = _default;